// import React, { useState, useEffect } from 'react';
// import PersonalDetailsStep from '../Enrollment/PersonalDetailsStep';
// import TypeSelectionStep from '../Enrollment/TypeSelectionStep';
// import SelectionStep from '../Enrollment/SelectionStep';
// import PricingStep from '../Enrollment/PricingStep';
// import PaymentStep from '../Enrollment/PaymentStep';
// import ProgressBar from '../Enrollment/ProgressBar';
// import PackageSelectionStep from '../Enrollment/PackageSelectionStep';

// const Enrollment = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({});

//   const updateFormData = (newData) => {
//     setFormData(prev => ({ ...prev, ...newData }));
//   };

//   const nextStep = () => {
//     setCurrentStep(prev => Math.min(prev + 1, 5));
//      window.scrollTo({
//       top:0,
//       behavior: "smooth"
//     })
//   };

//   const prevStep = () => {
//     setCurrentStep(prev => Math.max(prev - 1, 1));
//     window.scrollTo({
//       top:0,
//       behavior: "smooth"
//     })
//   };

//   const renderStep = () => {
//     switch (currentStep) {
//       case 1:
//         return (
//           <PersonalDetailsStep
//             data={formData}
//             onUpdate={updateFormData}
//             onNext={nextStep}
//           />
//         );
//       case 2:
//         return (
//           <TypeSelectionStep
//             data={formData}
//             onUpdate={updateFormData}
//             onNext={nextStep}
//             onBack={prevStep}
//           />
//         );
//       case 3:
//         return (
//           <SelectionStep
//             data={formData}
//             onUpdate={updateFormData}
//             onNext={nextStep}
//             onBack={prevStep}
//           />
//         );

//        case 4:
//         return (
//           <PackageSelectionStep
//             data={formData}
//             onUpdate={updateFormData}
//             onNext={nextStep}
//             onBack={prevStep}
//           />
//         );
//       case 5:
//         return (
//           <PricingStep
//             data={formData}
//             onUpdate={updateFormData}
//             onNext={nextStep}
//             onBack={prevStep}
//           />
//         );
//       case 6:
//         return (
//           <PaymentStep
//             data={formData}
//             onBack={prevStep}
//           />
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-900 py-8 pt-40">
//       <div className="max-w-4xl mx-auto px-4">
//         <div className="text-center mb-8">
//           <h1 className="text-3xl font-bold text-gray-100 mb-2">Universal Enrollment Form</h1>
//           <p className="text-gray-600">Complete your enrollment in 5 simple steps</p>
//         </div>

//         <ProgressBar currentStep={currentStep} totalSteps={5} />

//         <div className="bg-white rounded-lg shadow-lg p-8">
//           {renderStep()}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Enrollment;

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import {
  User,
  Mail,
  Phone,
  Ticket,
  CheckCircle,
  Loader2,
  ArrowLeft,
  Tag,
} from "lucide-react";

import { PayPalOneTimePaymentButton } from "@paypal/react-paypal-js/sdk-v6";

const EnrollmentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const itemId = searchParams.get("itemId");
  const packageId = searchParams.get("packageId");
  const [item, setItem] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showPromoCode, setShowPromoCode] = useState(false);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  /*
    Data coming from Course/Program details page

    {
      type: "course",
      itemId: "...",
      itemTitle: "React Development",
      packageId: "...",
      packageName: "Premium",
      price: 299
    }
  */

  // const enrollmentData = location.state;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    couponCode: "",
  });

  const [coupon, setCoupon] = useState(null);
  const [couponLoading, setCouponLoading] = useState(false);

  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentError, setPaymentError] = useState("");
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
  const [paymentEnrollment, setPaymentEnrollment] = useState(null);

  // useEffect(()=>{
  //   console.log("type", type);
  //   console.log("itemid", itemId);
  //   console.log("packageid", packageId);

  // },[]);

  useEffect(() => {
    const fetchEnrollmentData = async () => {
      if (!type || !itemId || !packageId) return;

      try {
        const endpoint =
          type === "course"
            ? `${BASE_URL}/courses/get-course-by-id/${itemId}`
            : `${BASE_URL}/program/get-program/${itemId}`;

        const response = await axios.get(endpoint);

        const itemData =
          response.data.course || response.data.program || response.data;
        setItem(itemData);

        // Find selected package
        const packages =
          type === "course"
            ? itemData.memberships || []
            : itemData.membershipPlan || [];

        console.log("first", packages);
        const selected = packages.find((pkg) => pkg._id === packageId);

        setSelectedPackage(selected);
      } catch (error) {
        console.error("Enrollment data error:", error);
      }
    };

    fetchEnrollmentData();
  }, [type, itemId, packageId]);

  const enrollmentData = {
    type,
    itemId,
    itemTitle: item?.title || item?.programHeading,

    packageId: selectedPackage?._id,

    packageName:
      type === "course" ? selectedPackage?.name : selectedPackage?.planName,

    price: selectedPackage?.price,

    name: "",
    email: "",
    phone: "",

    couponCode: "",
    discountAmount: 0,
    finalPrice: selectedPackage?.price || 0,
  };

  if (!enrollmentData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Enrollment information not found
          </h2>

          <button
            onClick={() => navigate("/")}
            className="mt-4 px-5 py-2 bg-blue-600 text-white rounded-lg"
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }
  /*
  |--------------------------------------------------------------------------
  | Calculate displayed price
  |--------------------------------------------------------------------------
  */

  const originalPrice = Number(enrollmentData.price || 0);

  let discountAmount = 0;

  if (coupon) {
    if (coupon.discountType === "percentage") {
      discountAmount =
        (originalPrice * Number(coupon.discountValue || 0)) / 100;

      if (
        coupon.maxDiscountAmount &&
        discountAmount > Number(coupon.maxDiscountAmount)
      ) {
        discountAmount = Number(coupon.maxDiscountAmount);
      }
    } else if (coupon.discountType === "fixed") {
      discountAmount = Number(coupon.discountValue || 0);
    }

    discountAmount = Math.min(discountAmount, originalPrice);
  }

  const finalPrice = Math.max(originalPrice - discountAmount, 0);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "couponCode" ? value.toUpperCase() : value,
    }));

    // If user changes the coupon code,
    // remove previously applied coupon
    if (name === "couponCode") {
      setCoupon(null);
      setPaymentError("");
    }
  };

  //applying coupon

  const handleApplyCoupon = async () => {
    const code = formData.couponCode.trim().toUpperCase();

    if (!code) {
      toast.error("Please enter a promo code");
      return;
    }

    if (!formData.email.trim()) {
      toast.error("Please enter your email first");
      return;
    }

    if (!originalPrice) {
      toast.error("Package price is not available");
      return;
    }

    try {
      setCouponLoading(true);
      setPaymentError("");

      const response = await axios.post(`${BASE_URL}/coupons/validate`, {
        code,
        email: formData.email.trim(),
        phone: formData.phone.trim(),
        amount: originalPrice,
        type,
        itemId,
        packageId,
      });

      console.log("Coupon validation response:", response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || "Invalid promo code");
      }

      /*
       * Your backend should return:
       *
       * {
       *   success: true,
       *   coupon: {...},
       *   discount: 100,
       *   originalAmount: 1799,
       *   finalAmount: 1699
       * }
       */

      const validatedCoupon = response.data.coupon;

      if (!validatedCoupon) {
        throw new Error("Coupon information was not returned");
      }

      setCoupon({
        ...validatedCoupon,

        // Keep calculated values also available
        discount: Number(response.data.discount || 0),

        originalAmount: Number(response.data.originalAmount || originalPrice),

        finalAmount: Number(response.data.finalAmount || originalPrice),
      });

      setFormData((prev) => ({
        ...prev,
        couponCode: code,
      }));

      toast.success(`Coupon ${code} applied successfully`);
    } catch (error) {
      console.error("Coupon validation error:", error);

      setCoupon(null);

      toast.error(
        error.response?.data?.message ||
          error.message ||
          "Invalid or expired promo code",
      );
    } finally {
      setCouponLoading(false);
    }
  };

  const handleRemoveCoupon = () => {
    setCoupon(null);

    setFormData((prev) => ({
      ...prev,
      couponCode: "",
    }));

    setShowPromoCode(false);
    setPaymentError("");

    toast.info("Promo code removed");
  };

  /*
  |--------------------------------------------------------------------------
  | Validation
  |--------------------------------------------------------------------------
  */

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error("Please enter your name");
      return false;
    }
    if (!formData.email.trim()) {
      toast.error("Please enter your email");
      return false;
    }
    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      toast.error("Please enter a valid email");
      return false;
    }
    if (!formData.phone.trim()) {
      toast.error("Please enter your phone number");
      return false;
    }

    return true;
  };

  const createPayPalOrder = async () => {
    if (!validateForm()) {
      throw new Error("Please complete your information first.");
    }

    try {
      setPaymentLoading(true);
      setPaymentError("");

      const response = await axios.post(
        `${BASE_URL}/payments/paypal/create-order`,
        {
          type,
          itemId,
          packageId,
          customer: {
            name: formData.name.trim(),
            email: formData.email.trim(),
            phone: formData.phone.trim(),
          },
          couponCode: coupon ? coupon.code : null,
        },
      );
      return {
        orderId: response.data.orderId,
      };
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Unable to create PayPal order";
      setPaymentError(message);
      toast.error(message);
      throw error;
    } finally {
      setPaymentLoading(false);
    }
  };

  const handlePayPalApprove = async (data) => {
    try {
      setPaymentLoading(true);

      const response = await axios.post(
        `${BASE_URL}/payments/paypal/capture-order`,
        {
          orderId: data.orderId,
          type,
          itemId,
          packageId,
          customer: {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
          },
          couponCode: formData.couponCode || null,
        },
      );

      if (response.data.success) {
        console.log("Payment successful:", response.data);

        // Store complete enrollment object
        setPaymentEnrollment(response.data.enrollment);

        // Show confirmation modal
        setShowPaymentSuccess(true);
      } else {
        throw new Error(response.data.message || "Payment capture failed");
      }
    } catch (error) {
      console.error("Payment capture error:", error);

      alert(
        error.response?.data?.message ||
          "Payment was completed but something went wrong while processing your enrollment.",
      );
    } finally {
      setPaymentLoading(false);
    }
  };
  /*
  |--------------------------------------------------------------------------
  | PayPal Error
  |--------------------------------------------------------------------------
  */

  const handlePayPalError = (error) => {
    console.error("PayPal error:", error);

    setPaymentError("Something went wrong with PayPal payment.");

    toast.error("Something went wrong with PayPal payment.");
  };

  /*
  |--------------------------------------------------------------------------
  | UI
  |--------------------------------------------------------------------------
  */

  return (
    <>
      <div className="bg-black h-32 md:h-[200px] text-center">
        <h1 className="text-lg lg:text-4xl font-bold text-white text-center content-center pt-16 lg:pt-32">
          Enrollment Process
        </h1>
      </div>

      <div className="min-h-screen bg-gray-50 py-10 px-4">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}

          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">
              Complete Your Enrollment
            </h1>

            <p className="text-gray-500 mt-2">
              Enter your information and complete your payment.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-3">
              <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6">
                <h2 className="text-xl font-bold text-gray-900 mb-6">
                  Enrollment Details
                </h2>

                <div className="space-y-5">
                  {/* Name */}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Full Name
                    </label>

                    <div className="relative">
                      <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />

                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter your full name"
                        className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>
                  </div>

                  {/* Email */}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email Address
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="you@example.com"
                        className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>
                  </div>
                  {/* Phone */}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="+1 555 123 4567"
                        className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>
                  </div>

                  {/* Coupon */}

                  {/* ================================= */}
                  {/* PROMO CODE */}
                  {/* ================================= */}

                  <div className="mt-5">
                    {!showPromoCode ? (
                      <button
                        type="button"
                        onClick={() => setShowPromoCode(true)}
                        className="flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700 hover:underline transition"
                      >
                        <Ticket className="w-4 h-4" />
                        Have a promo code?
                      </button>
                    ) : (
                      <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
                        {/* Header */}

                        <div className="flex items-center justify-between mb-3">
                          <label className="text-sm font-semibold text-gray-700">
                            Promo Code
                          </label>

                          <button
                            type="button"
                            onClick={() => {
                              setShowPromoCode(false);

                              setFormData((prev) => ({
                                ...prev,
                                couponCode: "",
                              }));

                              setCoupon(null);
                              setPaymentError("");
                            }}
                            className="text-xs text-gray-500 hover:text-red-600 transition"
                          >
                            Cancel
                          </button>
                        </div>

                        {/* Input */}

                        {!coupon ? (
                          <>
                            <div className="flex flex-col sm:flex-row gap-2">
                              <input
                                type="text"
                                name="couponCode"
                                value={formData.couponCode}
                                onChange={handleChange}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleApplyCoupon();
                                  }
                                }}
                                placeholder="Enter promo code"
                                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg
                focus:outline-none focus:ring-2 focus:ring-blue-500
                uppercase bg-white"
                              />

                              <button
                                type="button"
                                onClick={handleApplyCoupon}
                                disabled={
                                  couponLoading || !formData.couponCode.trim()
                                }
                                className="px-5 py-3 bg-gray-900 text-white rounded-lg
                hover:bg-gray-800 transition
                disabled:bg-gray-300 disabled:cursor-not-allowed
                flex items-center justify-center gap-2"
                              >
                                {couponLoading ? (
                                  <>
                                    <Loader2 className="w-4 h-4 animate-spin" />
                                    Checking...
                                  </>
                                ) : (
                                  "Apply"
                                )}
                              </button>
                            </div>

                            <p className="mt-2 text-xs text-gray-500">
                              Enter your promo code to receive a discount.
                            </p>
                          </>
                        ) : (
                          /* APPLIED COUPON */

                          <div className="rounded-lg border border-green-200 bg-green-50 p-4">
                            <div className="flex items-start justify-between gap-3">
                              <div className="flex items-center gap-3">
                                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-green-100">
                                  <CheckCircle className="h-5 w-5 text-green-600" />
                                </div>

                                <div>
                                  <p className="text-sm font-semibold text-green-700">
                                    Promo code applied
                                  </p>

                                  <p className="mt-1 font-bold tracking-wide text-green-800">
                                    {formData.couponCode}
                                  </p>
                                </div>
                              </div>

                              <button
                                type="button"
                                onClick={handleRemoveCoupon}
                                className="text-xs font-medium text-red-600 hover:text-red-700"
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sticky top-6">
                <h2 className="text-xl font-bold text-gray-900 mb-6">
                  Order Summary
                </h2>

                {/* Course / Program */}

                <div className="pb-5 border-b border-gray-200">
                  <p className="text-sm text-gray-500">
                    {type === "course" ? "Course" : "Program"}
                  </p>
                  <h3 className="text-lg font-bold text-gray-900 mt-1">
                    {enrollmentData.itemTitle}
                  </h3>
                </div>

                {/* Package */}
                <div className="py-5 border-b border-gray-200">
                  <div className="flex justify-between">
                    <div>
                      <p className="text-sm text-gray-500">Selected Package</p>
                      <p className="font-semibold text-gray-900 mt-1">
                        {enrollmentData.packageName}
                      </p>
                    </div>
                    <Tag className="w-5 h-5 text-blue-600" />
                  </div>
                </div>

                {/* Price */}

                <div className="space-y-3 py-5">
                  {/* Original Price */}

                  <div className="flex justify-between text-gray-600">
                    <span>Price</span>

                    <span className="font-medium">
                      ${originalPrice.toFixed(2)}
                    </span>
                  </div>

                  {/* Coupon */}

                  {coupon && (
                    <div className="flex justify-between items-center text-green-600">
                      <span className="flex items-center gap-2">
                        <span>Promo Discount</span>

                        <span className="text-xs bg-green-100 px-2 py-1 rounded font-semibold">
                          {formData.couponCode}
                        </span>
                      </span>

                      <span className="font-semibold">
                        -${discountAmount.toFixed(2)}
                      </span>
                    </div>
                  )}

                  {/* Divider */}

                  <div className="border-t border-gray-200 pt-4" />

                  {/* Final */}

                  <div className="flex justify-between items-center">
                    <span className="text-lg font-bold text-gray-900">
                      Total
                    </span>

                    <div className="text-right">
                      {coupon && (
                        <p className="text-sm text-gray-400 line-through">
                          ${originalPrice.toFixed(2)}
                        </p>
                      )}

                      <p className="text-2xl font-bold text-blue-600">
                        ${finalPrice.toFixed(2)}
                      </p>
                    </div>
                  </div>
                </div>
                {/* Payment */}
                <div className="mt-4">
                  {!formData.name || !formData.email || !formData.phone ? (
                    <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg text-sm text-yellow-800">
                      Please complete your name, email and phone number before
                      payment.
                    </div>
                  ) : (
                    <>
                      {paymentError && (
                        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
                          {paymentError}
                        </div>
                      )}
                      {paymentLoading && (
                        <div className="flex items-center justify-center gap-2 mb-3 text-gray-600">
                          <Loader2 className="w-4 h-4 animate-spin" />
                          Processing...
                        </div>
                      )}
                      <PayPalOneTimePaymentButton
                        createOrder={createPayPalOrder}
                        onApprove={handlePayPalApprove}
                        onError={handlePayPalError}
                        presentationMode="auto"
                      />
                    </>
                  )}
                </div>
                <p className="text-xs text-gray-500 text-center mt-4">
                  Your payment is securely processed through PayPal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPaymentSuccess && paymentEnrollment && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
          <div className="w-full max-w-lg rounded-2xl bg-white shadow-2xl overflow-hidden max-h-[90%] overflow-y-auto">
            {/* Header */}
            <div className="bg-green-600 px-6 py-5 text-white text-center">
              <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-white text-green-600 text-2xl">
                ✓
              </div>

              <h2 className="text-2xl font-bold">Payment Successful!</h2>

              <p className="mt-1 text-sm text-green-100">
                Your enrollment has been successfully created.
              </p>
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="mb-5 rounded-xl bg-gray-50 p-4">
                <h3 className="mb-4 text-lg font-semibold text-gray-800">
                  Enrollment Details
                </h3>

                <div className="space-y-3">
                  <div className="flex justify-between gap-4">
                    <span className="text-gray-500">Name</span>

                    <span className="font-medium text-gray-800 text-right">
                      {paymentEnrollment.name}
                    </span>
                  </div>

                  <div className="flex justify-between gap-4">
                    <span className="text-gray-500">Email</span>

                    <span className="font-medium text-gray-800 text-right break-all">
                      {paymentEnrollment.email}
                    </span>
                  </div>

                  <div className="flex justify-between gap-4">
                    <span className="text-gray-500">Phone</span>

                    <span className="font-medium text-gray-800">
                      {paymentEnrollment.phone}
                    </span>
                  </div>

                  <div className="flex justify-between gap-4">
                    <span className="text-gray-500">Package</span>

                    <span className="font-medium text-gray-800 text-right">
                      {paymentEnrollment.packageName}
                    </span>
                  </div>

                  <div className="flex justify-between gap-4">
                    <span className="text-gray-500">Original Price</span>

                    <span className="font-medium text-gray-800">
                      ₹{paymentEnrollment.originalPrice}
                    </span>
                  </div>

                  {paymentEnrollment.discountAmount > 0 && (
                    <div className="flex justify-between gap-4">
                      <span className="text-gray-500">Discount</span>

                      <span className="font-medium text-green-600">
                        -₹{paymentEnrollment.discountAmount}
                      </span>
                    </div>
                  )}

                  <div className="border-t pt-3 flex justify-between gap-4">
                    <span className="font-semibold text-gray-700">
                      Amount Paid
                    </span>

                    <span className="text-xl font-bold text-green-600">
                      ₹{paymentEnrollment.finalPrice}
                    </span>
                  </div>
                </div>
              </div>

              {/* Payment information */}
              <div className="rounded-xl border border-gray-200 p-4">
                <h3 className="mb-3 font-semibold text-gray-800">
                  Payment Information
                </h3>

                <div className="space-y-2 text-sm">
                  <div className="flex justify-between gap-3">
                    <span className="text-gray-500">Payment Status</span>

                    <span className="rounded-full bg-green-100 px-3 py-1 font-medium text-green-700">
                      {paymentEnrollment.paymentStatus}
                    </span>
                  </div>

                  <div className="flex justify-between gap-3">
                    <span className="text-gray-500">PayPal Order ID</span>

                    <span className="max-w-[220px] break-all text-right font-medium text-gray-700">
                      {paymentEnrollment.paypalOrderId}
                    </span>
                  </div>

                  <div className="flex justify-between gap-3">
                    <span className="text-gray-500">Capture ID</span>

                    <span className="max-w-[220px] break-all text-right font-medium text-gray-700">
                      {paymentEnrollment.paypalCaptureId}
                    </span>
                  </div>

                  <div className="flex justify-between gap-3">
                    <span className="text-gray-500">Enrollment ID</span>

                    <span className="max-w-[220px] break-all text-right font-medium text-gray-700">
                      {paymentEnrollment._id}
                    </span>
                  </div>
                </div>
              </div>

              {/* Button */}
              <button
                onClick={() => {
                  setShowPaymentSuccess(false);
                  navigate(-1);
                }}
                className="mt-6 w-full rounded-xl bg-orange-500 py-3 font-semibold text-white transition hover:bg-orange-600"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EnrollmentPage;
